import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { FileUtils } from 'src/app/@core/utils/file-utils';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { OnbaseService } from 'src/app/services/onbase.service';
import { ReportService } from 'src/app/services/report.service';
import { PosTakePhotoModalService } from './../../../../@core/services/pos-take-photo-modal.service';

@Component({
  selector: 'pos-documents-step',
  templateUrl: './documents-step.component.html',
  styleUrls: ['./documents-step.component.sass']
})
export class DocumentsStepComponent implements OnInit {

  @Input() documentsForm: FormArray = new FormArray([]);
  @Input() disabled = false;
  @Input() listOfBranchesNotValidateBiometry = "";
  @Output() pictureUrlEmitter = new EventEmitter<string>();
  constructor(private reportService: ReportService,
    private onbaseService: OnbaseService,
    private configService: ConfigurationService,
    private takePhotoModalService: PosTakePhotoModalService,
    private readonly exceptionSolutionService: ExceptionSolutionService) { }

  ngOnInit(): void {
  }

  getFormsAsFormGroupArray(forms: AbstractControl[]) {

    return forms as FormGroup[];
  }

  getFileForms(form: FormGroup) {


    let documents = form.controls.documents as FormArray;

    return documents.controls as FormGroup[];
  }


  onFileChange(event: any, i: number, form: FormGroup, id: string) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      let fileType = this.onbaseService.getFileType(file.name);

      if (!fileType.ext) {
        this.exceptionSolutionService.showAlertWithSolution(`<h2>¡Advertencia!</h2>`, `<h4>El archivo ${file.name} seleccionado no es soportado por el sistema</h4><h5 class="mb-3">Archivos soportados</h5><div class="row mr-0 mb-1"><div class="col-4"><svg class="svg-icon"><use href="./assets/fileIcons.svg#image"/></svg><span>JPG</span></div><div class="col-4"><svg class="svg-icon"><use href="./assets/fileIcons.svg#image"/></svg><span>JPEG</span></div><div class="col-4"><svg class="svg-icon"><use href="./assets/fileIcons.svg#image"/></svg><span>PNG</span></div></div><div class="row mr-0 mb-1"><div class="col-4"><svg class="svg-icon"><use href="./assets/fileIcons.svg#word"/></svg><span>DOC</span></div><div class="col-4"><svg class="svg-icon"><use href="./assets/fileIcons.svg#word"/></svg><span>DOCX</span></div><div class="col-4"><svg class="svg-icon"><use href="./assets/fileIcons.svg#pdf"/></svg><span>PDF</span></div></div><div class="row mr-0 mb-1"><div class="col-4"><svg class="svg-icon"><use href="./assets/fileIcons.svg#exel"/></svg><span>XLS</span></div><div class="col-4"><svg class="svg-icon"><use href="./assets/fileIcons.svg#exel"/></svg><span>XLSX</span></div><div class="col-4"><svg class="svg-icon"><use href="./assets/fileIcons.svg#exel"/></svg><span>CSV</span></div></div>`);
        return;
      }
      form.patchValue({
        [`document_${id}_${i.toString()}`]: file,
        [`document_fileName_${id}_${i.toString()}`]: file.name,
        [`document_ext_${id}_${i.toString()}`]: fileType.ext,
        [`document_documentType_${id}_${i.toString()}`]: fileType.code
      });
    }
  }

  getDescription(form: FormGroup, id: string, i: number) {
    return form.get(`description_${id}_${i.toString()}`)?.value;
  }

  getId(form: FormGroup, id: string, i: number) {
    return `id_${id}_${i.toString()}`;
  }

  getFilename(form: FormGroup, id: string, i: number) {
    return form.get(`document_fileName_${id}_${i.toString()}`)?.value || "Elija un archivo"
  }
  previewFile(form: FormGroup, id: string, i: number) {
    let file = form.get(`document_${id}_${i.toString()}`)?.value as File;

    this.reportService.printReport(file);
  }
  deleteFile(form: FormGroup, id: string, i: number) {
    form.patchValue({
      [`document_${id}_${i.toString()}`]: '',
      [`document_fileName_${id}_${i.toString()}`]: '',
      [`document_ext_${id}_${i.toString()}`]: '',
      [`document_documentType_${id}_${i.toString()}`]: '',
    });
    this.pictureUrlEmitter.emit('');
  }
  isUploaded(form: FormGroup, id: string, i: number) {
    return form.get(`document_fileName_${id}_${i.toString()}`)?.value ? true : false;
  }

  canShowTakePhotoButton(): boolean {
    return !this.listOfBranchesNotValidateBiometry.includes(this.configService.readSelectedBranchAndSalesOrg().branch.code);
  }

  getTakePhotoFlag(form: FormGroup, id: string, i: number) {
    return form.get(`document_show_take_photo_button_${id}_${i.toString()}`)?.value;
  }

  async showDialogToTakePhoto(form: FormGroup, id: string, i: number) {
    const picture = await this.takePhotoModalService.show();
    this.pictureUrlEmitter.emit(picture);
    const pictureFile = FileUtils.dataURLtoFile(picture || '', `document_fileName_${id}_${i.toString()}`);
    const fileType = this.onbaseService.getFileType(`${pictureFile?.name}.jpg`)
    form.patchValue({
      [`document_${id}_${i.toString()}`]: pictureFile,
      [`document_fileName_${id}_${i.toString()}`]: pictureFile?.name,
      [`document_ext_${id}_${i.toString()}`]: fileType.ext,
      [`document_documentType_${id}_${i.toString()}`]: fileType.code
    });
  }
}
